import { useState, useEffect } from "react";

export const AccessValidations = (initialMail = "", initialPassword = "", isRequestAccess = false, initialName = "") => {
    const [mail, setMail] = useState(initialMail);
    const [name,setName] = useState(initialName);
    const [password, setPassword] = useState(initialPassword);
    const [formError, setFormError] = useState({});
    const [isValid, setIsValid] = useState(false);

    //At least three characters before the @, and at least 5 after, and it must contain the ".com"
    const regex = /^[a-zA-Z]{3,}\S*@(?:\S*[a-zA-Z]){5,}\S*\.com(\.\S{2,3})?$/;

    const validateFields = (mail, nameOrPass) => {
        let errors = {};
        let isValid = true;

        if(!mail.trim()) {
            errors.mail = "El correo es obligatorio"
            isValid = false;
        } else if(!regex.test(mail)) {
            errors.mail = "Formato de correo inválido"
            isValid = false;
        }

        if (isRequestAccess) {
            if (!nameOrPass) {
                errors.name = "El nombre es obligatorio";
                isValid = false;
            }
        } else {
            if(!nameOrPass) {
                errors.password = "La contraseña es obligatoria"
                isValid = false;
            } else if(password.length < 8) {
                errors.password = "La contraseña debe tener al menos 8 caracteres"
                isValid = false;
            }
        }
        

        return {errors, isValid};
    }

    useEffect(() => {
        const secondaryField = isRequestAccess ? name : password;

        if (mail === "" && secondaryField === "") {
            setFormError({});
            setIsValid(isRequestAccess);
            return;
        }

        const timeout = setTimeout(() => {
            const {errors, isValid} = validateFields(mail, secondaryField);
            setFormError(errors);
            setIsValid(isValid);
        }, 300);

        return () => clearTimeout(timeout);
    }, [mail, name, password]);

    return {mail, name, password, formError, isValid, setMail, setName, setPassword, setFormError, setIsValid, validateFields};
}